import {
  LOAD_CAMPAIGN_SUCCESS,
  LOAD_CAMPAIGN_ERROR,
  LOAD_CAMPAIGN,
} from './constants';

export function loadingCampaign(campaignId, silent = false, fastLoad = false) {
  return {
    type: LOAD_CAMPAIGN,
    campaignId,
    silent,
    fastLoad,
  };
}

export function loadCampaignError(error) {
  return {
    type: LOAD_CAMPAIGN_ERROR,
    error,
  };
}

export function loadingCampaignSuccess(campaign) {
  return {
    type: LOAD_CAMPAIGN_SUCCESS,
    campaign,
  };
}



/** WEBPACK FOOTER **
 ** ./src/containers/campaign/actions.js
 **/